import { render, staticRenderFns } from "./saturnalia-info-iframe.vue?vue&type=template&id=3612bda4&scoped=true"
import script from "./saturnalia-info-iframe.vue?vue&type=script&lang=js"
export * from "./saturnalia-info-iframe.vue?vue&type=script&lang=js"
import style0 from "./saturnalia-info-iframe.vue?vue&type=style&index=0&id=3612bda4&prod&scoped=true&lang=css"
import style1 from "./saturnalia-info-iframe.vue?vue&type=style&index=1&id=3612bda4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3612bda4",
  null
  
)

export default component.exports